import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { MasterModelService } from 'src/app/share/services/master-model/master-model.service';
@Component({
    selector: 'app-vehicle-model-list',
    templateUrl: './vehicle-model-list.component.html',
    styleUrls: ['./vehicle-model-list.component.scss'],
    standalone: false
})
export class VehicleModelListComponent implements OnInit {
  customSearchFn = () => true;
  modelList: any[] = [];
  makeListr: any[] = [];
  vehicleMake: string = '';
  protected faEdit = faEdit;
  vehicleModelForm: FormGroup;
  showEditPopup: boolean = false;
  modelId!: string;
  popupType: string;
  errorMessage: any;
  vehicleMakeObj: any={}
  endOfResult:  boolean=false
  currentPageNumber: number=0;
  isToster: boolean = false;
  message: any;
  isLoading  : boolean= false;
  loader : boolean = false;
  filters:any={
    page:0
  }

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterModelService: MasterModelService,
  ){
    this.vehicleModelForm = this.formBuilder.group({
      name: [null, [ Validators.required]],
      vehicleMake: [null, [ Validators.required]],
    });
  }

  ngOnInit(): void {
    this.getVehicleModel();
    this.getVehicleMake();
    this.initData();
  }

  getVehicleModel(){
    this.loader = true;
    this.masterModelService.getModelDetails(this.filters).subscribe({
      next: (res:any) => {
      this.loader = false;
      if (this.filters.page === 0) {
      this.modelList = res.data;
      }
      if(res.data.length === 0){
        this.endOfResult = true;
      }
    },
      error: (error) => {
      this.errorMessage = error?.error?.error?.message;
      this.loader = false;
    }
    })
  }

  getVehicleMake(){
    this.masterModelService.getMakeDetails(this.vehicleMakeObj).subscribe((res:any) => {
      if(this.vehicleMakeObj.page == 0){
        this.makeListr = [];
        this.makeListr = res.data || [];
      } else {
        this.makeListr = this.makeListr.concat(res.data || []);
      }
    })
  }

  
  
  vehicleModelFormPopup(type:string,list?:any){
    this.errorMessage='' 
    if(type==='edit'){
      this.popupType='Update'
      this.vehicleModelForm.patchValue(list);
      this.vehicleModelForm.controls['vehicleMake'].setValue(list.vehicleMake);
      this.modelId = list._id;
      this.showEditPopup = true;
    }else{
      this.popupType='Add'
      this.showEditPopup = true;
    }
  }

  onEditSubmit() { 
    this.isLoading = true;
    if (this.popupType==='Update') {
      this.masterModelService.updateModelDetails(this.vehicleModelForm.value,this.modelId).subscribe({
      next: (res:any) => {
        this.isLoading = false;
        this.getVehicleModel();
        this.closePopup();
        this.isToster = true;
        this.message = res.message;
      },
      error: (error) => {
        this.errorMessage = error?.error?.error?.message;
        this.isLoading = false;
      }
    })
      
    }
    else{
      this.masterModelService.saveModelDetails(this.vehicleModelForm.value).subscribe({
        next: (res:any) => {
          this.isLoading = false;
          this.getVehicleModel();
          this.closePopup();
          this.isToster = true;
          this.message = res.message;
        },
        error: (error) => {
          this.errorMessage = error?.error?.error?.message;
          this.isLoading = false;
        }
      })
    }
  }

  initData(){
    this.vehicleMakeObj.searchTerm = "";
    this.getVehicleMake();
    this.getVehicleModel();
  }

  closePopup() {
    this.initData();
    this.showEditPopup = false;
    this.vehicleModelForm.reset();
  }

  onVehicleMakeInputChange(event:any){
    this.makeListr = [];
    this.vehicleMakeObj.page = 0;
    this.vehicleMakeObj.searchTerm = event?.term ? event.term : '';
    this.getVehicleMake();
  }

  scroll(){
    if(this.endOfResult){
      return;
    }
    this.currentPageNumber++;
    this.getVehicleMake()
  }

  closeToster(event: any){
    this.isToster = false;
  }

  FilterList(searchTerm: any) {
    this.filters.page = 0;
    this.endOfResult = false;
    this.modelList = [];
    this.filters.searchTerm = searchTerm || '';
    this.getVehicleModel();
  }

  loadMore(){
    if(this.endOfResult || this.loader) return;
    this.filters.page++;
    this.getVehicleModel();
  }
}
